import { FeatureFlagContextType } from './featureFlagContext';

export const FEATURES: FeatureFlagContextType = {
  isCASUploadKTPEnabled: process.env.REACT_APP_CAS_UPLOAD_KTP === 'true',
  isLiveNessEnabled: process.env.REACT_APP_LIVENESS_ENABLED === 'true',
  isGeoplaceRequired: process.env.REACT_APP_GEOPLACES_MANDATORY === 'true',
  isGeoplaceEnable: process.env.REACT_APP_GEOPLACES_ENABLED === 'true',
  isKTPWarningEnabled:
    process.env.REACT_APP_KTP_NOT_READABLE_WARNING === 'true',
  isEmailMandatory: process.env.REACT_APP_EMAIL_MANDATORY === 'true',
  isMapMandatory: process.env.REACT_APP_MAP_MANDATORY === 'true',
  isSameAddressRadioVisible:
    process.env.REACT_APP_DOMICILE_SAME_LEGAL_ADDRESS_RADIO === 'true',
  isChangePhoneNumberEnabled:
    process.env.REACT_APP_CHANGE_PHONE_NUMBER_ENABLED === 'true',
  isOnboardingServiceEnabled:
    process.env.REACT_APP_ONBOARDING_SERVICE_ENABLED === 'true',
  isForceSetPackageIdEnabled:
    process.env.REACT_APP_FORCE_SET_PACKAGE === 'true',
  isRedirectEnabled: process.env.REACT_APP_REDIRECT_ENABLED === 'true',
  isCancelAgeButtonEnabled:
    process.env.REACT_APP_CANCEL_BUTTON_AGE_RULES === 'true',
  googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY ?? '',
  addressDetailMinLength: Number(
    process.env.REACT_APP_ADDRESS_DETAIL_MIN_LENGTH,
  ),
  addressDetailMaxLength: Number(
    process.env.REACT_APP_ADDRESS_DETAIL_MAX_LENGTH,
  ),
  minAge: Number(process.env.REACT_APP_MIN_AGE),
  maxAge: Number(process.env.REACT_APP_MAX_AGE),
  spouseMinAge: Number(process.env.REACT_APP_SPOUSE_MIN_AGE),
  minAgeSingle: Number(process.env.REACT_APP_MIN_AGE_AND_SINGLE),
  isMapGeotaggingEnabled: process.env.REACT_APP_GEO_TAGGING_ENABLED === 'true',
  isHideGenderEnabled: process.env.REACT_APP_HIDE_GENDER_ENABLED === 'true',
  minRatingForPositiveFeedback: Number(
    process.env.REACT_APP_MIN_RATING_POSITIVE_FEEDBACK,
  ),
  isLeadReviveEnabled: process.env.REACT_APP_LEAD_REVIVE_ENABLED === 'true',
  isBpkbTaxStnkStatusVisible:
    process.env.REACT_APP_BPKB_TAX_STNK_STATUS === 'true',
};
